module.exports = __webpack_public_path__ + "static/media/regalo1.8f825a03.svg";